import { DaysOfWeek } from "./type";

export const dayJsToDaysOfWeekMap: Record<number, DaysOfWeek> = {
    0: DaysOfWeek.sunday,
    1: DaysOfWeek.monday,
    2: DaysOfWeek.tuesday,
    3: DaysOfWeek.wednesday,
    4: DaysOfWeek.thursday,
    5: DaysOfWeek.friday,
    6: DaysOfWeek.saturday,
};
